var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Dice',{attrs:{"value":_vm.course.students,"name":`course_dice_${_vm.course.id}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }